"use client";

import { APP_ROUTES } from "@/constants/routes";
import { montserrat } from "@/lib/font";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Dialog, IconButton } from "@mui/material";
import { useTranslations } from "next-intl";
import { usePathname, useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import IconShoppingCart from "../../../../../../../../components/icons/IconShoppingCart";

interface PopupPurchaseProps {
  handleClose: () => void;
  open: boolean;
  isLogin?: boolean;
  dataDetail?: any;
  locale?: string;
}

const PopupPurchase = (props: PopupPurchaseProps) => {
  const { open, handleClose, isLogin, dataDetail, locale } = props;
  const [currentUrl, setcurrentUrl] = useState<string>("");
  const pathName = usePathname();
  const path = usePathname();
  const id = path.split("/")[2];
  const router = useRouter();
  const handleRedirectPay = () => {
    router.push(
      APP_ROUTES(locale as any).PAYMENT.REPORT.ROOT.to.replace(
        ":id",
        dataDetail?.id
      )
    );
  };
  useEffect(() => {
    const handlePathChange = () => {
      const path =
        window.location.pathname +
        window.location.search +
        window.location.hash;
      setcurrentUrl(path);
    };
    handlePathChange();
  }, [pathName]);
  const t = useTranslations("messages");
  return (
    <Dialog
      maxWidth="sm"
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <Box className={`pt-4 pb-8 border-gray_20 ${montserrat}`}>
        <Box className="gap-6 grid px-6">
          <Box className="flex justify-between items-center">
            <Box className="flex items-center">
              <span
                className="text-gray_90 font-bold text-xl/7"
                translation-key="popup_purchase_title"
              >
                {t("popup_purchase_title")}
              </span>
            </Box>
            <Box>
              <IconButton
                className="!bg-eerie_black_5 size-8 !p-1"
                onClick={handleClose}
              >
                <CloseIcon className="text-[rgba(28, 28, 28, 0.4)]" />
              </IconButton>
            </Box>
          </Box>
          <Box>
            <span
              className="text-gray_90 text-sm/6 font-normal"
              translation-key="popup_purchase_description"
            >
              {t.rich("popup_purchase_description", {
                b: (chunk) => <b>{chunk}</b>,
                title: dataDetail?.title,
                priceVND: dataDetail?.priceVND,
                priceUSD: dataDetail?.priceUSD,
              })}
            </span>
          </Box>
          <Box className="gap-12 grid">
            <Box>
              <Button
                className="!py-1 !px-4 gap-2 flex !bg-ciBlue_900 w-full hover:!bg-cimigo_blue_light_1"
                onClick={
                  isLogin
                    ? handleRedirectPay
                    : () => {
                        router.push(
                          `${APP_ROUTES(locale as any).LOGIN.to}?redirect=${encodeURIComponent(currentUrl)}`
                        );
                      }
                }
              >
                <Box className="h-6 w-6">
                  <IconShoppingCart className="text-white" />
                </Box>
                <Box className="py-1 gap-[10px] grid">
                  <span
                    className="font-medium text-base/6 text-white normal-case"
                    translation-key="common_purchase_now"
                  >
                    {t("common_purchase_now")}
                  </span>
                </Box>
              </Button>
            </Box>
            <Box className="gap-4 grid">
              <Box>
                <span
                  translation-key="popup_purchase_no_subscription"
                  className="text-gray_90 text-sm/6 font-normal"
                >
                  {t("popup_purchase_no_subscription")}
                </span>
              </Box>
              <Box>
                <Button
                  variant="outlined"
                  className="!bg-ciBlue_200 w-full !rounded !py-1 !pl-2 !pr-3 gap-2 !flex !border-0 hover:!bg-ciBlue_2 hover:!border-[0.1px] hover:!border-ciBlue_light_2"
                  onClick={handleRedirectPay}
                >
                  <Box className="py-1 gap-[10px] grid">
                    <span
                      translation-key="popup_purchase_subscribe_now"
                      className="font-medium text-base/6 text-ciBlue_900 normal-case"
                    >
                      {t("popup_purchase_subscribe_now")}
                    </span>
                  </Box>
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default PopupPurchase;
